import { AuthGuard, LoginGuard } from '@nest/common-core-frontend-react';
import { Skeleton } from '@nest/uikit-react';
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
// import {
// 	ConfirmLoading,
// 	EnterQuantity,
// 	GoToLocation,
// 	GoToUnloadLocation,
// 	ScanHandlingUnit,
// 	ScanLocationOrHandlingUnit,
// 	ScanStockItem,
// 	Unload
// } from './features/wms-orchestrator/screens/outbound';
// import {
// 	ScanPickingHandlingUnit,
// 	WavelessEnterQuantity,
// 	WavelessGoToUnloadLocation,
// 	WavelessScanLocationForUnload,
// 	WavelessScanLocationOrHandlingUnit,
// 	WavelessScanStockItem,
// 	WavelessUnload
// } from './features/wms-orchestrator/screens/waveless';
import ConsignmentNoteDetailPage from './pages/ConsignmentNoteDetailPage';
import ConsignmentNoteFormPage from './pages/ConsignmentNoteFormPage';
import ConsignmentNotesCarriersPage from './pages/ConsignmentNotesCarriersPage';
import ConsignmentNotesCompletedListPage from './pages/ConsignmentNotesCompletedListPage';
import ConsignmentNotesListPage from './pages/ConsignmentNotesListPage';
import ConsignmentNotesPackedNotInContainerListPage from './pages/ConsignmentNotesPackedNotInContainerListPage';
import ConsignmentNotesScanPackagePage from './pages/ConsignmentNotesScanPackagePage';
import DeliveryDetailPage from './pages/DeliveryDetailPage';
import DeliveryListPage from './pages/DeliveryListPage';
import DeliveryReturnsPage from './pages/DeliveryNewReturnPage';
import DeliveryPage from './pages/DeliveryPage';
import DeliveryProcessPage from './pages/DeliveryProcessPage';
import DeliveryStopItemProcessPage from './pages/DeliveryStopItemProcessPage';
import DeliveryWriteOffReturnPage from './pages/DeliveryWriteOffReturnPage';
import HandlingUnitDetailPage from './pages/HandlingUnitDetailPage';
import InboundDeliveryOrderDetailPage from './pages/InboundDeliveryOrderDetailPage';
import InboundDeliveryOrderProcessItemPage from './pages/InboundDeliveryOrderProcessItemPage';
import InboundDeliveryOrderProcessPage from './pages/InboundDeliveryOrderProcessPage';
import InboundPage from './pages/InboundPage';
import InboundQueueDetailPage from './pages/InboundQueueDetailPage';
import InboundQueuesPage from './pages/InboundQueuesPage';
import InfoPage from './pages/InfoPage';
import MoveHandlingUnitPage from './pages/MoveHandlingUnitPage';
import MovePage from './pages/MovePage';
import MoveStockItemPage from './pages/MoveStockItemPage';
import MyWarehouseRelationsPage from './pages/MyWarehouseRelationsPage';
import OutboundDeliveryOrderDetailPage from './pages/OutboundDeliveryOrderDetailPage';
import OutboundDeliveryOrderProcessItemPage from './pages/OutboundDeliveryOrderProcessItemPage';
import OutboundDeliveryOrderProcessPackPage from './pages/OutboundDeliveryOrderProcessPackPage';
import OutboundDeliveryOrderProcessPage from './pages/OutboundDeliveryOrderProcessPage';
import OutboundPage from './pages/OutboundPage';
import OutboundQueueDetailPage from './pages/OutboundQueueDetailPage';
import OutboundQueuesPage from './pages/OutboundQueuesPage';
import OutboundWavelessListPage from './pages/OutboundWavelessListPage';
import OutboundWavelessPreviewPage from './pages/OutboundWavelessPreviewPage';
import OutboundWavelessProcessPage from './pages/OutboundWavelessProcessPage';
import OutboundWavelessUnloadPage from './pages/OutboundWavelessUnloadPage';
import PackageUnitDetailPage from './pages/PackageUnitDetailPage';
import { StockItemDetailPage } from './pages/StockItemDetailPage';
import StorageLocationDetailPage from './pages/StorageLocationDetailPage';

const MainLayout = lazy(() => import('./layout/MainLayout'));

const HomePage = lazy(() => import('./pages/HomePage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const NotFoundPage = lazy(() => import('./pages/NotFound'));

const PageLoadingFallback = () => (
	<div className="flex flex-col gap-2 p-4">
		<Skeleton className="h-4 w-full" />
		<Skeleton className="h-4 w-full" />
		<Skeleton className="h-4 w-full" />
		<Skeleton className="h-4 w-full" />
	</div>
);

export const Router = () => {
	return (
		<Routes>
			<Route path="auth" element={<LoginGuard />}>
				<Route
					path="login"
					element={
						<Suspense fallback={<PageLoadingFallback />}>
							<LoginPage />
						</Suspense>
					}
				/>
			</Route>
			<Route
				path="/"
				element={
					<AuthGuard
						unauthorizedComponent={
							<Suspense fallback={<PageLoadingFallback />}>
								<LoginPage />
							</Suspense>
						}
					/>
				}
			>
				<Route
					element={
						<Suspense fallback={<PageLoadingFallback />}>
							<MainLayout />
						</Suspense>
					}
				>
					<Route path="" element={<HomePage />} />
					<Route path="info" element={<InfoPage />} />
					<Route path="storage/locations/:id" element={<StorageLocationDetailPage />} />
					<Route path="handling-units/:id" element={<HandlingUnitDetailPage />} />
					<Route path="warehouse-relations/:id" element={<MyWarehouseRelationsPage />} />
					<Route path="my-warehouse-relations" element={<MyWarehouseRelationsPage />} />
					<Route path="stock-items/:id" element={<StockItemDetailPage />} />
					<Route path="inbound" element={<InboundPage />} />
					<Route path="inbound/:documentTypeId/queues" element={<InboundQueuesPage />} />
					<Route path="inbound/:documentTypeId/queues/:queueId" element={<InboundQueueDetailPage />} />
					<Route path="inbound/delivery/orders/:inboundDeliveryOrderId" element={<InboundDeliveryOrderDetailPage />} />
					<Route path="inbound/delivery/orders/:inboundDeliveryOrderId/process" element={<InboundDeliveryOrderProcessPage />} />
					<Route path="inbound/delivery/orders/:inboundDeliveryOrderId/process/:lineId" element={<InboundDeliveryOrderProcessItemPage />} />
					<Route path="inbound/delivery/orders/:inboundDeliveryOrderId/process/line/:lineId" element={<InboundDeliveryOrderProcessItemPage />} />

					{/* Outbound */}
					<Route path="outbound" element={<OutboundPage />} />
					<Route path="outbound/:documentTypeId/queues" element={<OutboundQueuesPage />} />
					<Route path="outbound/:documentTypeId/queues/:queueId" element={<OutboundQueueDetailPage />} />
					<Route path="outbound/delivery/orders/:id" element={<OutboundDeliveryOrderDetailPage />} />
					<Route path="outbound/delivery/orders/:id/process" element={<OutboundDeliveryOrderProcessPage />} />
					<Route path="outbound/delivery/orders/:outboundDeliveryOrderId/process/line/:lineId" element={<OutboundDeliveryOrderProcessItemPage />} />
					<Route path="outbound/delivery/orders/:id/process/pack" element={<OutboundDeliveryOrderProcessPackPage />} />
					<Route path="outbound/:documentTypeId/waveless/:queueId" element={<OutboundWavelessPreviewPage />} />
					<Route path="outbound/:documentTypeId/waveless/:queueId/list" element={<OutboundWavelessListPage />} />
					<Route path="outbound/:documentTypeId/waveless/:queueId/unload" element={<OutboundWavelessUnloadPage />} />
					<Route path="outbound/:documentTypeId/waveless/:queueId/process" element={<OutboundWavelessProcessPage />} />

					{/* Move */}
					<Route path="move" element={<MovePage />} />
					<Route path="move/handling-unit" element={<MoveHandlingUnitPage />} />
					<Route path="move/stock-item" element={<MoveStockItemPage />} />

					{/* Consignment notes */}
					<Route path="consignment-notes/carriers" element={<ConsignmentNotesCarriersPage />} />
					<Route path="consignment-notes/carriers/:carrierId/list" element={<ConsignmentNotesListPage />} />
					<Route path="consignment-notes/carriers/:carrierId/packed-not-in-container" element={<ConsignmentNotesPackedNotInContainerListPage />} />
					<Route path="consignment-notes/carriers/:carrierId/packed-not-in-container/:packageUnitId" element={<PackageUnitDetailPage />} />
					<Route path="consignment-notes/carriers/:carrierId/completed" element={<ConsignmentNotesCompletedListPage />} />
					<Route path="consignment-notes/carriers/:carrierId/list/:consignmentNoteId" element={<ConsignmentNoteDetailPage />} />
					<Route path="consignment-notes/carriers/:carrierId/new" element={<ConsignmentNoteFormPage />} />
					<Route path="consignment-notes/scan-package" element={<ConsignmentNotesScanPackagePage />} />

					{/* Delivery */}
					<Route path="delivery" element={<DeliveryPage />} />
					<Route path="delivery/list" element={<DeliveryListPage />} />
					<Route path="delivery/returns/new" element={<DeliveryReturnsPage />} />
					<Route path="delivery/returns/write-off" element={<DeliveryWriteOffReturnPage />} />
					<Route path="delivery/list/:shipmentRouteId" element={<DeliveryDetailPage />} />
					<Route path="delivery/list/:shipmentRouteId/process/:warehouseRelationId" element={<DeliveryProcessPage />} />
					<Route path="delivery/list/:shipmentRouteId/process/:warehouseRelationId/stops/:shipmentStopId/stocks/:stockItemId" element={<DeliveryStopItemProcessPage />} />

					{/* WMS Orchestrator */}
					{/* <Route path="work-session/proposal" element={<WorkSessionProposal />} />
					<Route path="work-session/scan-handling-unit" element={<ScanHandlingUnit />} />
					<Route path="work-session/go-to-location" element={<GoToLocation />} />
					<Route path="work-session/scan-stock-item" element={<ScanStockItem />} />
					<Route path="work-session/enter-quantity" element={<EnterQuantity />} />
					<Route path="work-session/scan-location-or-handling-unit" element={<ScanLocationOrHandlingUnit />} />
					<Route path="work-session/go-to-unload-location" element={<GoToUnloadLocation />} />
					<Route path="work-session/confirm-loading" element={<ConfirmLoading />} />
					<Route path="work-session/unload" element={<Unload />} />
					<Route path="work-session/scan-picking-handling-unit" element={<ScanPickingHandlingUnit />} />
					<Route path="work-session/waveless-scan-location-or-handling-unit" element={<WavelessScanLocationOrHandlingUnit />} />
					<Route path="work-session/waveless-scan-stock-item" element={<WavelessScanStockItem />} />
					<Route path="work-session/waveless-enter-quantity" element={<WavelessEnterQuantity />} />
					<Route path="work-session/waveless-go-to-unload-location" element={<WavelessGoToUnloadLocation />} />
					<Route path="work-session/waveless-scan-location-for-unload" element={<WavelessScanLocationForUnload />} />
					<Route path="work-session/waveless-unload" element={<WavelessUnload />} /> */}
				</Route>

				<Route
					path="*"
					element={
						<Suspense fallback={<PageLoadingFallback />}>
							<NotFoundPage />
						</Suspense>
					}
				/>
			</Route>
		</Routes>
	);
};
